import { render, staticRenderFns } from "./AskDialog.vue?vue&type=template&id=b7c84056&"
import script from "./AskDialog.vue?vue&type=script&lang=js&"
export * from "./AskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports